module.exports = __webpack_public_path__ + "static/media/infected.dbb2cc81.png";